export const SET_PENDING = "state/receiving-sites/SET_PENDING";
export const SET_TOUCHED = "state/receiving-sites/SET_TOUCHED";
export const SET_RECEIVING_SITES = "state/receiving-sites/SET_RECEIVING_SITES";
export const FORGET_RECEIVING_SITES =
  "state/receiving-sites/FORGET_RECEIVING_SITES";
